import { Alert as BsAlert } from 'react-bootstrap5';

export default BsAlert;
